app.service('productAvailabilityShopList', function(
	productAvailabilityService,
	productAvailabilityShopMap,
	productAvailabilityShopTabs
) {
	let $self, $shopList;

	function setElements() {
		$self = $('.product-availability');
		$shopList = $self.find('.shop-list');
	}

	function hide() {
		$shopList.hide();
	}

	function show() {
		$shopList.show();
	}

	function update(html) {
		$shopList.html(html);
		expandFirstItemOnTheList();
	}

	function expandFirstItemOnTheList() {
		$shopList
			.find('.shop-city-item:first-child .shop-item')
			.addClass('expanded');
	}

	function handleToggleShopDetails(e) {
		$(this).toggleClass('expanded');
	}

	function handleShowOnMapClick() {
		const shopCode = $(this).data('shop-code');

		productAvailabilityShopTabs.changeTab('MAP');
		productAvailabilityShopMap.zoom(shopCode);
	}

	function setEvents() {
		$('body').on('click', '.js-shop', handleToggleShopDetails);

		$('body').on('click', '.js-show-on-map', handleShowOnMapClick);
	}

	function init() {
		setElements();
		setEvents();
	}

	return {
		init,
		hide,
		show,
		update
	};
});
